// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ratingContainer__2WUxo{margin-top:10px;font-size:14px;display:inline-flex;align-items:center}.ratingContainer__2WUxo>button{margin-left:10px}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/ProductRating.module.scss"],"names":[],"mappings":"AAAA,wBACE,eAAgB,CAChB,cAAe,CACf,mBAAoB,CACpB,kBAAmB,CAJrB,+BAMI,gBAAiB","file":"ProductRating.module.scss","sourcesContent":[".ratingContainer {\n  margin-top: 10px;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  > button {\n    margin-left: 10px;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"ratingContainer": "ratingContainer__2WUxo"
};
module.exports = exports;
